export default "__VITE_ASSET__BeBt_pmD__"